export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const API_BASE = 'https://ttcg.directaffinitycx.net/api/v1'
export const API_BASE_SYC = 'https://tcsyc.directaffinitycx.net/api/v1'
export const API_BASE_CRM = 'https://tcgcrm.directaffinitycx.net/api/v1'
// export const API_BASE = 'http://localhost:3022/api/v1'
export const AUTH_API_KEY='f84fa777-35e5-4ceb-b18a-beae2f4e1df1'